import React from 'react'
import {
  StackProps,
  Stack,
  Card,
  StarRating,
  Heading,
  Text,
  Flex,
  Box,
  Icon,
} from '@thirstycamel/ui'
import type { ReviewEntity } from '@ts/core/src/modules/review/review.entity'
import dayjs from 'dayjs'

export interface ProductReviewCardProps extends StackProps {
  review: ReviewEntity
}

export const ProductReviewCard = ({ review, ...restProps }: ProductReviewCardProps) => {
  const createdAt = dayjs(review.createdAt).format('D MMMM YYYY')

  return (
    <Stack as={Card} spacing={4} px={6} py={6} {...restProps}>
      <Flex direction={['column-reverse', 'row']} justify="space-between">
        <StarRating value={review.rating} size="lg" />

        <Text fontFamily="heading" mb={[2, 0]}>
          {createdAt} -{' '}
          <Box as="span" color="pink.500">
            {review.firstName}
          </Box>{' '}
          {review.age}, {review.region}
        </Text>
      </Flex>

      <Heading>{review.title}</Heading>

      <Text>{review.message}</Text>

      <Stack isInline align="center" spacing={3}>
        <Icon
          name={review.recommends ? 'check' : 'close'}
          color={review.recommends ? 'green.500' : 'blackAlpha.600'}
          fontSize="lg"
        />
        <Text fontFamily="heading">
          {review.recommends ? 'Yes, I' : 'No, I do not'} recommend this product
        </Text>
      </Stack>
    </Stack>
  )
}

export default ProductReviewCard
